import DataLink from "./DataLink";

export default DataLink;